/* import __COLOCATED_TEMPLATE__ from './confirm-transfer-modal.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { notEmpty, or, reads } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { getDisplayNameForSquareupTender } from '@square/dashboard-data/utils/card-brand';
import { v4 as uuid } from 'uuid';
import { Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import { Action, Feature, Page, Target, getEvent, getAppletFromSource } from '@banking/ui/utils/checking/event-catalog';
let ConfirmTransferModal = (_dec = notEmpty('depositInfo.bankAccount.accountNumberSuffix'), _dec2 = notEmpty('instantPayoutInstrument.bankAccountSummary'), _dec3 = or('isRTPBankAccountDeposit', 'isLegacyBankAccountDeposit'), _dec4 = or('instantPayoutInstrument.bankAccountSummary.bankName', 'legacyBankName'), _dec5 = or('instantPayoutInstrument.bankAccountSummary.accountNumberSuffix', 'legacyBankAccountSuffix'), _dec6 = or('instantPayoutInstrument.cardSummary.panSuffix', 'depositInfo.card.panSuffix'), _dec7 = reads('depositInfo.depositAmount.formatted'), (_class = class ConfirmTransferModal extends Component {
  get cardBrandName() {
    return this.instantPayoutInstrument?.cardSummary ? getDisplayNameForSquareupTender(this.instantPayoutInstrument.cardSummary.brand, this.intl) : undefined;
  }
  get cardBrand() {
    return this.cardBrandName || this.cards.getBrandName(this.depositInfo?.card?.brand);
  }
  get instantDepositFeeRate() {
    return this.formatter.basisPoints(this.feeBasisPoints, {
      minimumFractionDigits: 0
    });
  }
  get currentBalance() {
    if (this.depositInfo?.maxInstantDepositAmount) {
      return this.depositInfo?.maxInstantDepositAmount.formatted;
    }
    const total = this.depositInfo?.depositAmount.add(this.depositInfo?.feeAmount);
    return total.get('formatted');
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor, this);
    _initializerDefineProperty(this, "cards", _descriptor2, this);
    _initializerDefineProperty(this, "events", _descriptor3, this);
    _initializerDefineProperty(this, "formatter", _descriptor4, this);
    _initializerDefineProperty(this, "intl", _descriptor5, this);
    _initializerDefineProperty(this, "instantTransfer", _descriptor6, this);
    _initializerDefineProperty(this, "instantPayoutInstrument", _descriptor7, this);
    _initializerDefineProperty(this, "currentUnitToken", _descriptor8, this);
    _initializerDefineProperty(this, "depositInfo", _descriptor9, this);
    _initializerDefineProperty(this, "feeBasisPoints", _descriptor10, this);
    _initializerDefineProperty(this, "isLegacyBankAccountDeposit", _descriptor11, this);
    _initializerDefineProperty(this, "isRTPBankAccountDeposit", _descriptor12, this);
    _initializerDefineProperty(this, "isBankAccountDeposit", _descriptor13, this);
    _initializerDefineProperty(this, "legacyBankName", _descriptor14, this);
    _initializerDefineProperty(this, "legacyBankAccountSuffix", _descriptor15, this);
    _initializerDefineProperty(this, "bankName", _descriptor16, this);
    _initializerDefineProperty(this, "bankAccountSuffix", _descriptor17, this);
    _initializerDefineProperty(this, "cardEnding", _descriptor18, this);
    _initializerDefineProperty(this, "amountReadyForInstantDeposit", _descriptor19, this);
    _initializerDefineProperty(this, "createTransferIdempotenceKey", _descriptor20, this);
    _initializerDefineProperty(this, "locationName", _descriptor21, this);
    _initializerDefineProperty(this, "isLoading", _descriptor22, this);
    _initializerDefineProperty(this, "dropdownOpen", _descriptor23, this);
    this.createTransferIdempotenceKey = uuid();
    this.setLocationName();
  }
  async setLocationName() {
    const unitOwnerships = Owner.create({
      id: this.currentUnitToken,
      type: OwnerType.UNIT
    });
    const response = await this.bankingAccountApi.listAccounts([unitOwnerships]);
    if (response) {
      this.locationName = response?.[0].name;
    }
  }
  _getAndTrackCdpEvent(properties) {
    const cdpEvent = getEvent({
      applet: getAppletFromSource(this.args.modalOptions.es2EventSource),
      feature: Feature.InstantTransfer,
      ...properties
    });
    this.events.track({
      kind: 'CDP',
      event: {
        name: cdpEvent.name,
        properties: cdpEvent.properties
      }
    });
  }
  _trackCdpSubmit() {
    this._getAndTrackCdpEvent({
      action: Action.Click,
      page: Page.ConfirmDetails,
      target: Target.SubmitTransfer
    });
  }
  _trackCdpError() {
    this._getAndTrackCdpEvent({
      action: Action.View,
      page: Page.TransferError
    });
  }
  _trackCdpSuccess() {
    this._getAndTrackCdpEvent({
      action: Action.View,
      page: Page.TransferComplete
    });
  }
  cancel() {
    this.args.close({
      cancel: true
    });
  }
  async sendDeposit() {
    this._trackCdpSubmit();
    this.isLoading = true;
    try {
      const result = await this.instantTransfer.createTransfer({
        idempotenceKey: this.createTransferIdempotenceKey,
        unitToken: this.currentUnitToken,
        amountCents: this.depositInfo.depositAmount.amount,
        currencyCode: this.depositInfo.depositAmount.currencyCode,
        destinationInstrumentToken: this.instantPayoutInstrument ? this.instantPayoutInstrument.instrumentToken : null
      });
      if (result.failure) {
        this._trackCdpError();
        this.args.instantPayoutSuccess(null, {
          title: result.statusMessage.title,
          description: result.statusMessage.description
        });
      } else {
        this._trackCdpSuccess();
        this.args.instantPayoutSuccess(result.balanceActivity);
      }
    } catch {
      this._trackCdpError();
      this.args.instantPayoutSuccess(null, {
        title: this.intl.t('banking.instantTransfers.confirmTransferModal.genericErrorTitle'),
        description: this.intl.t('banking.instantTransfers.confirmTransferModal.genericErrorDescription')
      });
    } finally {
      this.isLoading = false;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cards", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "events", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "instantTransfer", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "instantPayoutInstrument", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalOptions.instantPayoutInstrument;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "currentUnitToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalOptions.currentUnitToken;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "depositInfo", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalOptions.depositInfo;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "feeBasisPoints", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.modalOptions.feeBasisPoints;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isLegacyBankAccountDeposit", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isRTPBankAccountDeposit", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "isBankAccountDeposit", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "legacyBankName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.depositInfo?.bankAccount?.bankCodeInfo?.name;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "legacyBankAccountSuffix", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.depositInfo?.bankAccount?.accountNumberSuffix;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "bankName", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "bankAccountSuffix", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "cardEnding", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "amountReadyForInstantDeposit", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "createTransferIdempotenceKey", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "locationName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "dropdownOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendDeposit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendDeposit"), _class.prototype)), _class));
export { ConfirmTransferModal as default };